import {
  DocumentAnalysisLineItemInput,
  LineItemInput,
  TaxType,
} from '@admiin-com/ds-graphql';
import LineItemInputTable from './LineItemsTable';

interface Props {
  setRows: (rows: DocumentAnalysisLineItemInput[]) => void;
  rows: DocumentAnalysisLineItemInput[];
  defaultGST?: TaxType;
  hasServiceLookup?: boolean;
  fromEntityId?: string;
  noGstInclusive?: boolean;
}

export const transferLineItemInputToDocumentAnalysisLineItemInput = (
  lineItem: LineItemInput
): DocumentAnalysisLineItemInput => {
  return {
    description: lineItem.description,
    taxType: lineItem.taxType,
    price: lineItem.lineAmount,
    quantity: lineItem.quantity,
    unitPrice: lineItem.unitAmount,
  };
};

export const transferDocumentAnalysisLineItemInputToLineItemInput = (
  lineItem: DocumentAnalysisLineItemInput
): LineItemInput => {
  return {
    description: lineItem.description,
    taxType: lineItem.taxType,
    lineAmount: lineItem.price,
    quantity: lineItem.quantity,
    unitAmount: lineItem.unitPrice,
  };
};

export default function DocumentAnalysisInputTable({
  defaultGST = TaxType.NO_GST,
  hasServiceLookup = false,
  fromEntityId,
  noGstInclusive,
  ...props
}: Props) {
  return (
    <LineItemInputTable
      defaultGST={defaultGST}
      hasServiceLookup={hasServiceLookup}
      fromEntityId={fromEntityId}
      noGstInclusive={noGstInclusive}
      setRows={(rows) => {
        const newRows =
          rows?.map((row) =>
            transferLineItemInputToDocumentAnalysisLineItemInput(row)
          ) ?? [];
        props.setRows(newRows);
      }}
      rows={
        (props.rows as LineItemInput[])?.map((row) =>
          transferDocumentAnalysisLineItemInputToLineItemInput(row)
        ) ?? []
      }
    />
  );
}
